import * as Yup from "yup";
import { passwordValidations } from "../../../validations";

export const validationSchema = Yup.object().shape({
  ...passwordValidations,
});
